import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import globalHelpers from './helpers/global'
import router from './router'
import store from './store'
import Toast, { TYPE } from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueGtag from "vue-gtag";
import Hotjar from 'vue-hotjar'
import config from '@/config';

Vue.config.productionTip = false

// Load stored access token if available
const token = localStorage.getItem('access_token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

Vue.mixin(globalHelpers)
Vue.use(Toast, {
  [TYPE.ERROR]: {
    timeout: 10000,
  },
  [TYPE.SUCCESS]: {
    timeout: 3000,
  }
});

// Analytics
if (config.app_env === 'production') {
  const storeRefId = localStorage.getItem('store_ref_id')

  // Global site tag (gtag.js) - Google Analytics
  Vue.use(VueGtag, {
    config: { 
      id: "UA-180643985-2",
      params: {
        // dimension1 is matching custom dimension with name `store_ref_id` in Google Analytics
        'dimension1': storeRefId
      } 
    }
  }, router);

  // Hotjar Tracking Code for https://mpo.everli.com
  Vue.use (Hotjar, {
    id: '2043050'
  })
}

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
